import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=e2cc7c3a&"
import script from "./InventoryView.vue?vue&type=script&lang=js&"
export * from "./InventoryView.vue?vue&type=script&lang=js&"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=e2cc7c3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports